import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const normalizeUser = (u) => {
    if (!u) return null;
    return {
      id: u.id || u.Id,
      email: u.email || u.Email,
      fullName: u.fullName || u.FullName || '',
      phone: u.phone || u.Phone || '',
      role: u.role || u.Role,
      customerId: u.customerId || u.CustomerId || null,
    };
  };

  const [user, setUser] = useState(() => {
    try { return normalizeUser(JSON.parse(localStorage.getItem('user'))); } catch { return null; }
  });
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      api.get('/auth/me')
        .then(res => {
          const normalized = normalizeUser(res.data);
          setUser(normalized);
          localStorage.setItem('user', JSON.stringify(normalized));
        })
        .catch(() => {
          logout();
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const normalized = normalizeUser(res.data.user);
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(normalized));
    setToken(res.data.token);
    setUser(normalized);
    return normalized;
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const isStaff = user?.role === 'admin' || user?.role === 'staff';
  const isAdmin = user?.role === 'admin';

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, isStaff, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
